import { useModuleFederationContext } from '@msdk/common'
import { FormCustomTabDefinition } from '@msdk/definitions'
import React, { useEffect } from 'react'

import { ApplicationError } from '../ApplicationError'
import { ImportedComponentErrorBoundary } from '../ImportedComponentBoundary'

interface Props {
  tabDef: FormCustomTabDefinition
}

export function CustomTab(props: Props) {
  const { ensureModule, loadedModules } = useModuleFederationContext()

  useEffect(() => {
    ensureModule('CUSTOM', props.tabDef.componentName, props.tabDef.msProvider, undefined, true)
  }, [])

  const isModuleLoaded = !!loadedModules[props.tabDef.msProvider]

  const getTabComponent = (): any => {
    const msModule = loadedModules[props.tabDef.msProvider]
    if (msModule) {
      const ImportedComponent = msModule[props.tabDef.componentName]
      return (
        <ImportedComponentErrorBoundary>
          <ImportedComponent />
        </ImportedComponentErrorBoundary>
      )
    }
  }

  return (
    <>
      {isModuleLoaded && getTabComponent()}
      {isModuleLoaded && !getTabComponent() && <ApplicationError type="BadRequest" />}
    </>
  )
}
